"use client";
import { Typography } from "antd";
import React from "react";

const RulesPage = () => {
  const { Title } = Typography;

  return (
    <div
      className="container flex flex-col pt-28 sm:pt-32 md:pt-36 mid:!pt-44 xl:!pt-48 gap-16 sm:gap-14 pb-24 md:pb-32 lg:pb-40"
      id="rules"
    >
      <div className="flex flex-col w-full items-center">
        <Title level={1} className="H1 text-center">
          قوانین و مقررات استفاده از خدمات
        </Title>
      </div>
      <div className="flex flex-col gap-4 lg:gap-14">
        <div className="flex flex-col w-full">
          <Title level={2} className="H2 !text-lg lg:!text-xl">
            1. معرفی
          </Title>
          <ul className="list-inside">
            <li className="text-regal-black-lighter !text-sm lg:!text-base !leading-8">
              این وب‌سایت متعلق به شرکت تابرق(فراناب افزار آریا) بوده و خدمات ما
              شامل واردات مستقیم پنل‌های خورشیدی، احداث و بازسازی نیروگاه‌های
              خورشیدی است. استفاده از این سایت به منزله‌ی پذیرش قوانین و مقررات
              زیر خواهد بود.{" "}
            </li>
          </ul>
        </div>
        <div className="flex flex-col w-full">
          <Title level={2} className="H2 !text-lg lg:!text-xl">
            2. مسئولیت‌ها
          </Title>
          <ul className="list-disc list-inside pr-10">
            <li className="text-regal-black-lighter !text-sm lg:!text-base !leading-8">
              تمامی اطلاعات درج‌شده درباره‌ی تجهیزات، قیمت‌ها و خدمات به‌روز و
              معتبر است؛ با این حال ممکن است بدون اطلاع قبلی تغییر کند.
            </li>
            <li className="text-regal-black-lighter !text-sm lg:!text-base !leading-8">
              شرکت مسئولیتی در قبال خسارات ناشی از استفاده‌ی نادرست از تجهیزات
              یا نصب غیراصولی خارج از تیم فنی ما نخواهد داشت.
            </li>
          </ul>
        </div>
        <div className="flex flex-col w-full">
          <Title level={2} className="H2 !text-lg lg:!text-xl">
            3. ثبت سفارش و پرداخت
          </Title>
          <ul className="list-disc list-inside pr-10">
            <li className="text-regal-black-lighter !text-sm lg:!text-base !leading-8">
              قیمت‌ها به‌صورت رقابتی و شفاف اعلام می‌شوند.{" "}
            </li>
            <li className="text-regal-black-lighter !text-sm lg:!text-base !leading-8">
              کاربر موظف است هنگام ثبت سفارش اطلاعات صحیح ارائه کند.
            </li>
            <li className="text-regal-black-lighter !text-sm lg:!text-base !leading-8">
              در صورت بروز خطا در پرداخت یا ثبت سفارش، کاربر می‌تواند موضوع را
              از طریق بخش پشتیبانی پیگیری کند.{" "}
            </li>
          </ul>
        </div>
        <div className="flex flex-col w-full">
          <Title level={2} className="H2 !text-lg lg:!text-xl">
            4. نصب و بهره‌برداری
          </Title>
          <ul className="list-disc list-inside pr-10">
            <li className="text-regal-black-lighter !text-sm lg:!text-base !leading-8">
              خدمات احداث نیروگاه خورشیدی شامل بررسی محل، طراحی، اخذ مجوز، نصب
              تجهیزات و اتصال به شبکه است.
            </li>
            <li className="text-regal-black-lighter !text-sm lg:!text-base !leading-8">
              زمان‌بندی و شرایط دقیق اجرای پروژه در قرارداد جداگانه با مشتری
              مشخص می‌شود.
            </li>
            <li className="text-regal-black-lighter !text-sm lg:!text-base !leading-8">
              راندمان و عملکرد نیروگاه منوط به رعایت دستورالعمل‌های فنی و
              نگهداری صحیح توسط مشتری خواهد بود.{" "}
            </li>
          </ul>
        </div>
        <div className="flex flex-col w-full">
          <Title level={2} className="H2 !text-lg lg:!text-xl">
            5. مالکیت معنوی{" "}
          </Title>
          <ul className="list-disc list-inside pr-10">
            <li className="text-regal-black-lighter !text-sm lg:!text-base !leading-8">
              تمامی محتوا، تصاویر و اطلاعات موجود در سایت متعلق به شرکت است و
              استفاده‌ی تجاری یا انتشار بدون اجازه‌ی کتبی ممنوع می‌باشد.{" "}
            </li>
          </ul>
        </div>
        <div className="flex flex-col w-full">
          <Title level={2} className="H2 !text-lg lg:!text-xl">
            6. حریم خصوصی
          </Title>
          <ul className="list-disc list-inside pr-10">
            <li className="text-regal-black-lighter !text-sm lg:!text-base !leading-8">
              اطلاعات کاربران تنها برای ارائه‌ی بهتر خدمات استفاده شده و محرمانه
              باقی خواهد ماند.
            </li>
            <li className="text-regal-black-lighter !text-sm lg:!text-base !leading-8">
              اطلاعات شخصی کاربران بدون حکم قانونی در اختیار اشخاص ثالث قرار
              نخواهد گرفت.
            </li>
          </ul>
        </div>
        <div className="flex flex-col w-full">
          <Title level={2} className="H2 !text-lg lg:!text-xl">
            7. حل اختلاف
          </Title>
          <ul className="list-disc list-inside pr-10">
            <li className="text-regal-black-lighter !text-sm lg:!text-base !leading-8">
              هرگونه اختلاف ناشی از استفاده از خدمات ابتدا از طریق مذاکره و
              پشتیبانی حل‌وفصل خواهد شد.
            </li>
            <li className="text-regal-black-lighter !text-sm lg:!text-base !leading-8">
              در صورت عدم توافق، موضوع از طریق مراجع قانونی ذی‌صلاح پیگیری
              می‌شود.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default RulesPage;
